export const GDPR_TOGGLE_ENABLED = 'gdprToggleEnabled';
export const LEGAL_BASIS_REQUIREMENT_ENABLED = 'legalBasisRequirementEnabled';